import type { Config, ClientConfig } from "./types/types.ts";

export const SDK_VERSION: number = 209;
const HOST: string = "https://analyticsserver.anthraai.com";
export const DEFAULT_COOKIE_EXPIRATION: number = 730; // Days

export const DEFAULT_CONFIG: Config = {
  enabled: true,
  api_root: HOST,
  auto_track_events: [`click`, `submit`],
  cookie_expiration: DEFAULT_COOKIE_EXPIRATION,
  name: ``,
  domain: ``,
  cookie_prefix: `_klaritics_`,
  idle_time_out: 3600,
  ed_t_time: -1,
  sct_time: 10800000
};

export const DEFAULT_CLIENT_CONFIG: ClientConfig = {
  debug: false,
  honorDNT: false,
  idle_time_out: 3600,
  client_id: null,
  session_id: null,
  version: `ALL`,
  events_upload_time: -1,
  retry_time: -1,
  bulk_upload: true,
  auto_event_logging: false
};

export const KEY_PREFIX = `klaritics_`;
export const KEY = `KLARITICS`;

export const LOCAL_STORAGE = `local_storage`;

export const SESSION_STORAGE = `session_storage`;

export const actionEventsList: string[] = [`$app_opened`, `install`];

export const ON_KEY = `on`;

export const BROWSERS: Record<string, string> = {
  OperaMini: `Opera Mini`,
  Opera: `Opera`,
  BlackBerry: `BlackBerry`,
  IEMobile: `Internet Explorer Mobile`,
  Edge: `Microsoft Edge`,
  FB: `Facebook Mobile`,
  Chrome: `Chrome`,
  ChromeIOS: `Chrome iOS`,
  UC: `UC Browser`,
  FirefoxIOS: `Firefox iOS`,
  SafariMobile: `Mobile Safari`,
  Safari: `Safari`,
  AndroidMobile: `Android Mobile`,
  Konqueror: `Konqueror`,
  Firefox: `Firefox`,
  IE: `Internet Explorer`,
  Mozilla: `Mozilla`,
  Brave: `Brave`
};

/** Permanent Keys */
export const KLARITICS_USER_ID: string = `${KEY_PREFIX}id`;
export const KLARITICS_CLIENT_EVENTS_KEY: string = `_${KEY_PREFIX}client_events`;
export const KLARITICS_CONFIG_KEY: string = `_${KEY_PREFIX}config`;
export const KLARITICS_USER_ATTR_KEY: string = `_${KEY_PREFIX}ua`;
export const KLARITICS_SYNC: string = `_${KEY_PREFIX}sc`;
export const KLARITICS_EVENTS_LOGGED: string = `_${KEY_PREFIX}evl`;
export const KLARITICS_LAST_ENABLE_DISABLE_TIME: string = `_${KEY_PREFIX}ledt`;
export const KLARITICS_LAST_ENABLED_FLAG: string = `_${KEY_PREFIX}lef`;
export const KLARITICS_CONFIG_HASH: string = `_${KEY_PREFIX}ch`;
export const KLARITICS_CLIENT_EVENTS_HASH: string = `_${KEY_PREFIX}ceh`;
export const KLARITICS_LAST_CONFIG_TIME: string = `_${KEY_PREFIX}lct`;
export const KLARITICS_USER_INFO_HASH: string = `_${KEY_PREFIX}uih`;
export const KLARITICS_INSTALL_KEY: string = `${KEY_PREFIX}in`;
export const APP_VERSION_KEY: string = `${KEY_PREFIX}ver`;
export const KLARITICS_LAST_BG_TIME_KEY: string = `${KEY_PREFIX}lbgt`;
export const ENABLE_KEY: string = `enable`;
export const DETAILS_KEY: string = `details`;
export const KLARITICS_STATUS_KEY: string = `status`;
export const KLARITICS_STATUS_SUCCESS: string = `SUCCESS`;
export const KLARITICS_STATUS_FAILURE: string = `FAILURE`;
export const APXOR_STATUS_KEY: string = `apxor_status`;
// export const KLARITICS_STATUS_SUCCESS: string = `APXOR_STATUS_SUCCESS`;
// export const KLARITICS_STATUS_FAILURE: string = `APXOR_STATUS_FAILURE`;
export const VISIBLE: string = `visible`;
export const FOREGROUND: string = `FOREGROUND`;
export const BACKGROUND: string = `BACKGROUND`;
export const KLARITICS_PAGE_OPENED: string = `$page_opened`;
export const KLARITICS_APP_OPENED: string = `$app_opened`;
export const REFERRER_KEY: string = `referrer`;
export const AUTOMATION_KEY: string = `automation`;
export const PLATFORM_KEY: string = `platform`;
export const DATA_SAVE_MODE_KEY: string = `data_save_mode`;
export const NETWORK_KEY: string = `network`;
export const USER_EVENT: string = `USER_EVENT`;
export const SYSTEM_EVENT: string = `SYSTEM_EVENT`;
export const NAVIGATION_EVENT: string = `NAVIGATION_EVENT`;
export const APP_EVENT: string = `APP_EVENT`;
export const CLIENT_EVENT: string = `CLIENT_EVENT`;
export const REATINED_SESSIONS: string = `${KEY_PREFIX}retained_session`;
export const QE_STATE: string = `qe_state`;
export const DEVICE_TYPE: string = `device_type`;

// Chunk and Session keys
export const KLARITICS_LAST_EVENT_TIME: string = `_${KEY_PREFIX}lEt`;
export const KLARITICS_SESSION_ID: string = `_${KEY_PREFIX}sId`;
export const KLARITICS_CURRENT_CHUNK: string = `_${KEY_PREFIX}cd`;
export const OLD_SESSIONS_DATA: string = `_${KEY_PREFIX}od`;
export const KLARITICS_LT_COUNT: string = `_${KEY_PREFIX}lt_count`;
export const KLARITICS_UNSENT_CHUNK_DETAILS: string = `_${KEY_PREFIX}use`;
export const KLARITICS_SESSION_CHUNK_NUMBER_MAP: string = `_${KEY_PREFIX}scnm`;
export const KLARITICS_RETAINED_DAYS: string = `${KEY_PREFIX}retained_days`;
export const KLARITICS_SESSION_START_TIME: string = `${KEY_PREFIX}sst`;

// Termination keys
export const KLARITICS_TERMINATION_ID: string = `${KEY_PREFIX}termination_ID`;

export const klariticsKeys: string[] = [
  `${KEY_PREFIX}debug_enable`,
  `${KEY_PREFIX}log_level`,
  `_${KEY_PREFIX}config`,
  `${KEY_PREFIX}id`,
  `${KEY_PREFIX}ver`,
  `${KEY_PREFIX}in`,
  `_${KEY_PREFIX}od`,
  `_${KEY_PREFIX}use`,
  `_${KEY_PREFIX}cd`,
  `${KEY_PREFIX}retained_session`,
  `${KEY_PREFIX}retained_days`,
  `_${KEY_PREFIX}ua`,
  `_${KEY_PREFIX}sc`,
  `_${KEY_PREFIX}ledt`,
  `_${KEY_PREFIX}lef`,
  `_${KEY_PREFIX}ch`,
  `_${KEY_PREFIX}lct`,
  `_${KEY_PREFIX}uih`,
  `${KEY_PREFIX}lbgt`,
  `_${KEY_PREFIX}lEt`,
  `_${KEY_PREFIX}sId`,
  `_${KEY_PREFIX}lt_count`,
  `${KEY_PREFIX}sst`,
  `${KEY_PREFIX}termination_ID`,
  `_${KEY_PREFIX}ew`,
  `_${KEY_PREFIX}scnm`,
  `_${KEY_PREFIX}td`
];
